<template>
  <div>
    <div class="main" v-if="$store.state.isMobile == 2">
      <!-- 热招职位 -->
      <div class="hotposition">
        <img src="@/assets/img/join/title.png" alt="" class="titleImg">
        <div class="tit animate__animated animate__zoomIn" src="" alt=""></div>
        <bannerJoin v-if="$store.state.editStatus === 0" :type="14" :list="bannerList" :bannerLink="bannerLink"
          @onReturn="bannerDate" />
        <!-- <div
        class="topTitle wow animate__animated animate__zoomIn"
        data-wow-delay="1.0s"
      > -->
        <div class="titouter  animate__animated animate__zoomIn">
          <div class="topTitle animate__animated animate__zoomIn">
            <div class="chinese">热招职位</div>
            <div class="english">HOT RECRUITMENT POSITIONS</div>
          </div>
          <div class="list">
            <template>
              <div class="item" @click="toOther(item.keyEnName)" v-for="(item, index) in bannerLink"
                :key="item.keyEnName" :style="{ backgroundImage: 'url(' + getImg(index) + ')' }">
                {{ item.keyName }}</div>
            </template>
            <!-- <div class="item" @click="toOther()">社会招聘入口</div>
            <div class="item" @click="toOther()">24校招生招聘入口</div>
            <div class="item" @click="toOther()">实习生招聘入口</div> -->
          </div>
          <!-- <editButton v-if="$store.state.editStatus === 0" :type="1" :list="bannerList" @onReturn="bannerDate" ></editButton> -->
        </div>

      </div>

      <!-- 员工活动 -->
      <div class="welfare animate__animated animate__zoomIn">
        <div class="topTitle wow animate__animated animate__zoomIn" data-wow-delay="1.0s">
          <div class="chinese">员工活动</div>
          <div class="english">EMPLOYEE ACTIVITIES</div>
        </div>
        <div class="example flexCenter">

          <swiper class="swiper" v-bind:options="swiperOption" v-if="bannerSwiper.length > 0">
            <swiper-slide class="slide" v-for="item in bannerSwiper">
              <div class="item">
                <img :src="item.imgUrl" alt="" />
                <div>{{ item.titleMain }}</div>
              </div>
            </swiper-slide>
            <!-- <swiper-slide class="slide" >
              <div class="item">
                <img src="../../assets/img/join/activity.png" alt="" />
                <div>金秋九月共庆生</div>
              </div>

            </swiper-slide>
            <swiper-slide class="slide">
              <div class="item">
                <img src="../../assets/img/join/activity2.png" alt="" />
                <div>校招培训</div>
              </div>
            </swiper-slide> -->
            <!-- <swiper-slide class="slide">
            <div class="item">
              <img src="../../assets/img/join/activity3.png" alt="" />
              <div>导师带教</div>
            </div>
          </swiper-slide> -->
            <!-- <swiper-slide class="slide">
              <div class="item">
                <img src="../../assets/img/join/activity4.png" alt="" />
                <div>舞台表演</div>
              </div>
            </swiper-slide>
            <swiper-slide class="slide">
              <div class="item">
                <img src="../../assets/img/join/activity5.png" alt="" />
                <div>学习活动</div>
              </div>
            </swiper-slide>
            <swiper-slide class="slide">
              <div class="item">
                <img src="../../assets/img/join/activity6.png" alt="" />
                <div>活动聚餐</div>
              </div>
            </swiper-slide>
            <swiper-slide class="slide">
              <div class="item">
                <img src="../../assets/img/join/activity7.png" alt="" />
                <div>集体培训</div>
              </div>
            </swiper-slide> -->
            <!-- <swiper-slide class="slide">
            <div class="item">
              <img src="../../assets/img/join/activity8.png" alt="" />
              <div>管理员培训</div>
            </div>
          </swiper-slide> -->
            <!-- <swiper-slide class="slide">
              <div class="item">
                <img src="../../assets/img/join/activity9.png" alt="" />
                <div>户外锻炼</div>
              </div>
            </swiper-slide>
            <swiper-slide class="slide">
              <div class="item">
                <img src="../../assets/img/join/activity10.png" alt="" />
                <div>发布会</div>
              </div>
            </swiper-slide> -->


          </swiper>

        </div>
      </div>
      <editSwiper v-if="$store.state.editStatus === 0" :type="15" :list="bannerSwiper" @onReturn="bannerDate">
      </editSwiper>
    </div>
    <mobileJoin v-else />
    <CopyRight></CopyRight>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import mobileJoin from "../mobile/mobileJoin.vue";
import { banner } from "@/api/public"
import { addCommonData, getCommonDataList } from "@/api/news"
export default {
  name: "Join",
  components: {
    swiper,
    swiperSlide,
    mobileJoin
  },
  data() {
    return {
      swiperOption: {
        loop: true, // 是否循环
        autoplay: {
          delay: 2500, // 自动播放的时长
        },
        speed: 2500,
        slidesPerView: "auto", // 设置可视区一共显示几张图片,设置auto,设置auto为自适应;
        centeredSlides: true, // 设置为true时,带有active-slide类名的图片会居中
        spaceBetween: 40, //  每张图片之间的间隔
      },
      bannerList: [],      //banner
      bannerLink: [],      //热招职位
      bannerSwiper: [],    //swiper
    };
  },
  created() {

  },
  mounted() {
    window.scrollTo(0, 0);
    this.$wow.init();
    if (this.$store.state.isMobile == 2) {
      // banner({ isRelease: this.$store.state.editStatus, type: 14 }).then(res => {
      //   this.bannerList = res.data;
      // })
      this.initialise()
      window.scrollTo(0, 0);
      console.log(this.$route.query.type);
      if (this.$route.query.type == "market") {
        this.active_index = 0;
      } else if (this.$route.query.type == "activity") {
        this.active_index = 1;
      }
    }
  },
  methods: {
    getImg(index) {
      let ind = index + 1
      ind = ind > 3 ? 3 : ind
      return require('../../assets/img/join/base' + ind + '.png')
    },
    toOther(e) {
      window.open(
        // "https://jobs.51job.com/all/coVDFUMVQ_UWsBbVQzUD0.html?timestamp__1258=muDQiK0IMG7D8Dla%2B6nAxIhD0xWTIyxvD&alichlgref=https%3A%2F%2Fwe.51job.com%2F"
        e
      );
    },
    initialise(event) {
      let whileData = '0'
      if (event) {
        whileData = event
      }
      if (this.$store.state.isMobile == 2) {
        // banner
        if (whileData == '0' || whileData == '14') {
          banner({ isRelease: this.$store.state.editStatus, type: 14 }).then(res => {
            this.bannerList = res.data;
            if (res.data.length > 0) {
              setTimeout(() => {
                document.querySelector('.hotposition').style.backgroundImage = `url(${this.bannerList[0].imgUrl})`;
              }, 100);
              this.$forceUpdate()
            }
          })

        }
        // 热招职位
        if (whileData == '0' || whileData == 'hot_recruitment_positions') {
          getCommonDataList({ isRelease: this.$store.state.editStatus, commonData: 'hot_recruitment_positions' }).then(res => {
            this.bannerLink = res.data;
            this.$forceUpdate()
            if (this.bannerList.length > 0) {
              // document.querySelector('.top_native').style.backgroundImage = `url(${this.bannerList[0].imgUrl})`;
            }
          })
        }
        //swiper
        if (whileData == '0' || whileData == '15') {
          banner({ isRelease: this.$store.state.editStatus, type: 15 }).then(res => {
            this.bannerSwiper = res.data;
            if (res.data.length > 0) {
              setTimeout(() => {
                // document.querySelector('.hotposition').style.backgroundImage = `url(${this.bannerList[0].imgUrl})`;
              }, 100);
              this.$forceUpdate()
            }
          })

        }
      }

    },
    bannerDate(v, e) {
      if (e == 'hot_recruitment_positions') {
        this.bannerLink = JSON.parse(JSON.stringify(v))
      } else if (e == '14') {
        this.bannerList = JSON.parse(JSON.stringify(v))
      } else if (e == '15') {
        this.bannerSwiper = JSON.parse(JSON.stringify(v))
      }
      this.initialise(e)
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width:767px) {

  .main {
    margin-top: 60px;

    >div {
      width: 100%;
      overflow: hidden;
      // background-size: cover;
    }

    .topTitle {
      color: #00398a;
      padding: 20px;
    }
  }

  .swiper {
    width: 80%;

    .slide {
      width: 375px;
    }
  }

  .welfare {
    // height: 460px;
    height: 590px;
    background: url(../../assets/img/join/welfare.png) no-repeat center;
    background-size: cover;

    .topTitle {
      text-align: center;
    }

    .example {
      flex-direction: row;
      margin-top: 50px;

      .item {
        // width: 325px;
        width: 375px;

        margin: 0 150px;
        border: 4px solid #ffffff;
        box-shadow: 0px 2px 8px 0px rgba(155, 206, 253, 0.48);

        img {
          width: 375px;
          height: 250px;
          display: block;
        }

        >div {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 600;
          color: #333333;
          line-height: 27px;
          background: #fff;
        }
      }
    }
  }

  .hotposition {
    position: relative;
    text-align: left;
    background: url(../../assets/img/join/recruitment.png) no-repeat center;
    background-size: cover;
    height: calc(100vh - 60px);

    .titleImg {
      position: absolute;
      left: 200px;
      top: 150px;
    }

    .tit {
      width: 430px;
      height: 225px;
      margin-top: 235px;
      margin-left: 200px;
    }

    .titouter {
      margin-top: 50px;
      width: 800px;
      text-align: center !important;
      z-index: 100000;
    }

    .topTitle {
      width: 100%;
      text-align: center;
      margin-right: 300px;

      .chinese {
        font-size: 35px;
      }
    }

    .list {
      display: flex;
      justify-content: center;

      .item {
        width: 209px;
        height: 54px;
        // background: url(../../assets/img/join/base.png) no-repeat center;
        background: url(../../assets/img/join/base3.png) no-repeat center;
        margin: 0 10px;
        border-radius: 10px;
        background-size: cover;
        line-height: 54px;
        font-size: 18px;
        font-weight: 400;
        color: #f8f8f8;
        cursor: pointer;
      }

      .item:hover {
        font-weight: 900;
      }
    }
  }


}
</style>
